<template>
  <div>
    <fwb-textarea
      v-model="patterns"
      :rows="4"
      label="Add numbers to block"
      placeholder="Add a new number or number pattern, one per line." />

    <div class="actions pt-5">
      <fwb-button color="default" @click="updateBlocklist">
        Update Blocklist
      </fwb-button>
    </div>

    <div class="actions mt-10 border-t border-gray-200 pt-5">
      <vue-slim-tables
        ref="table"
        :source="tableSource"
        :columns="columns"
        class="table">
        <template #thead="{ columns: tableColumns }">
          <tr>
            <th
              v-for="(column) in tableColumns"
              :key="column.key"
              :class="column.class">
              {{ column.title }}
            </th>
          </tr>
        </template>

        <template #row="{ row }">
          <tr>
            <td>
              {{ row.pattern }}
            </td>
            <td>
              <fwb-button @click="deletePattern(row.pattern)" size="xs" color="light">
                Remove
              </fwb-button>
            </td>
          </tr>
        </template>
      </vue-slim-tables>
    </div>
  </div>
</template>

<script setup>
import { watch, ref } from 'vue'
import { FwbTextarea, FwbButton } from 'flowbite-vue'
import VueSlimTables from 'vue-slim-tables'
import qs from 'qs'
import { toastError } from '~/javascript/utils/toast'
import securedAxios from '../../utils/axios'

const axios = securedAxios()

const table = ref()

const columns = [
  { title: 'Number/Pattern', key: 'pattern' },
  { title: 'Action', key: 'action', class: 'w-48' }
]

const patterns = ref('')
const allowCharactersRegex = /[^0-9*\n]/g

async function tableSource() {
  let response = null

  try {
    response = await axios.get('/ajax/blocklist')
  } catch (error) {
    toastError(error)
  }

  return response?.data || []
}

async function updateBlocklist() {
  const patternsList = patterns.value.split('\n').filter((str) => str.trim() !== '')

  try {
    await axios.patch(
      '/ajax/blocklist',
      {
        add_patterns: patternsList,
        paramsSerializer(json) {
          return qs.stringify(json, { arrayFormat: 'brackets' })
        }
      }
    )

    patterns.value = ''
  } catch (error) {
    toastError(error)
  }

  table?.value?.reload()
}

async function deletePattern(pattern) {
  try {
    await axios.patch(
      '/ajax/blocklist',
      {
        remove_pattern: pattern,
        paramsSerializer(json) {
          return qs.stringify(json, { arrayFormat: 'brackets' })
        }
      }
    )
  } catch (error) {
    toastError(error)
  }

  table?.value?.reload()
}

watch(patterns, (newValue) => {
  patterns.value = newValue.replace(allowCharactersRegex, '')
})
</script>

<style scoped>

</style>
